import React, { useCallback, useEffect, useRef, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Tabs, Chip, Modal, Person, img, fmt, when } from "./kit";

// telefon genisliginde tablolar kart olur, destek sohbeti liste -> konusma olarak acilir
const useNarrow = () => {
  const q = "(max-width: 991px)";
  const [n, setN] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const m = window.matchMedia(q);
    const f = () => setN(m.matches);
    m.addEventListener("change", f);
    return () => m.removeEventListener("change", f);
  }, []);
  return n;
};

const Cards = ({ items, empty = "Kayıt yok." }) =>
  items.length === 0 ? (
    <div className="card">
      <div className="badu-empty">{empty}</div>
    </div>
  ) : (
    <div style={{ display: "grid", gap: 8 }}>
      {items.map((c) => (
        <div key={c.key} className="card" style={{ margin: 0 }}>
          <div className="card-body" style={{ padding: 12 }}>
            {c.body}
          </div>
        </div>
      ))}
    </div>
  );

const ScrollTabs = (props) => (
  <div className="badu-scrolltabs" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch", margin: "0 -4px", padding: "0 4px" }}>
    <div style={{ width: "max-content" }}>
      <Tabs {...props} />
    </div>
  </div>
);

// ------------------------------------------------------- musteri hizmetleri
const Support = () => {
  const [status, setStatus] = useState("open");
  const [threads, setThreads] = useState([]);
  const [unread, setUnread] = useState(0);
  const [active, setActive] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const endRef = useRef(null);
  const narrow = useNarrow();

  const loadThreads = useCallback(async () => {
    const r = await api.supportThreads({ status });
    if (r?.status) {
      setThreads(r.threads);
      setUnread(r.unread);
    }
  }, [status]);

  const openThread = useCallback(async (t) => {
    const r = await api.supportThread(t._id);
    if (r?.status) {
      setActive(r.thread);
      setMessages(r.messages);
      setTimeout(() => endRef.current?.scrollIntoView({ block: "end" }), 50);
    }
  }, []);

  useEffect(() => {
    loadThreads();
    const t = setInterval(() => {
      loadThreads();
      if (active) openThread(active);
    }, 10000);
    return () => clearInterval(t);
  }, [loadThreads, openThread, active]);

  const send = async () => {
    if (!text.trim() || !active) return;
    const r = await api.supportReply(active._id, text.trim());
    if (!r?.status) return window.alert(r?.message || "Gönderilemedi");
    setText("");
    openThread(active);
    loadThreads();
  };

  const quick = ["Merhaba, size nasıl yardımcı olabiliriz?", "Talebinizi inceliyoruz, kısa süre içinde dönüş yapacağız.", "Coin yüklemenizi kontrol ettik, hesabınıza tanımlandı.", "Sorununuz çözüldü, iyi eğlenceler!"];

  return (
    <div className="row">
      <div className="col-lg-4" style={narrow && active ? { display: "none" } : undefined}>
        <Tabs value={status} onChange={setStatus} tabs={[["open", "Açık"], ["closed", "Kapalı"], ["", "Tümü"]]} />
        <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 8 }}>Okunmamış konuşma: <b>{unread}</b></div>
        <div className="card" style={{ maxHeight: narrow ? "none" : "65vh", overflow: "auto" }}>
          {threads.length === 0 ? (
            <div className="badu-empty">Konuşma yok</div>
          ) : (
            threads.map((t) => (
              <div
                key={t._id}
                onClick={() => openThread(t)}
                style={{ padding: narrow ? "12px" : "10px 12px", borderBottom: "1px solid #F1F5F9", cursor: "pointer", background: active?._id === t._id ? "#EEF2FF" : "transparent" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <Person image={t.userImage} name={t.userName || "Kullanıcı"} />
                  {t.unreadAdmin > 0 && <Chip kind="bad">{t.unreadAdmin}</Chip>}
                </div>
                <div style={{ fontSize: 12, color: "#6B7280", marginTop: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {t.lastMessage}
                </div>
                <div style={{ fontSize: 11, color: "#9CA3AF" }}>
                  {when(t.lastAt)} {t.isHost ? "· Yayıncı" : ""}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <div className="col-lg-8" style={narrow && !active ? { display: "none" } : undefined}>
        {!active ? (
          <div className="card">
            <div className="badu-empty">Soldan bir konuşma seç.</div>
          </div>
        ) : (
          <div className="card">
            <div className="card-body" style={narrow ? { padding: 10 } : undefined}>
              <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: 10, gap: 8 }}>
                {narrow && (
                  <button className="btn btn-sm btn-outline-secondary" style={{ flexShrink: 0 }} onClick={() => setActive(null)} aria-label="Geri">
                    ←
                  </button>
                )}
                <div style={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
                  <Person image={active.userImage} name={active.userName} />
                </div>
                <button className="btn btn-sm btn-outline-secondary" style={{ flexShrink: 0 }} onClick={async () => { await api.supportStatus(active._id, active.status === "open" ? "closed" : "open"); openThread(active); loadThreads(); }}>
                  {active.status === "open" ? (narrow ? "Kapat" : "Konuşmayı kapat") : "Yeniden aç"}
                </button>
              </div>
              <div style={{ height: narrow ? "calc(100dvh - 330px)" : "48vh", minHeight: 260, overflow: "auto", background: "#F8FAFC", borderRadius: 12, padding: 12 }}>
                {messages.map((m) => (
                  <div key={m._id} style={{ display: "flex", justifyContent: m.from === "admin" ? "flex-end" : "flex-start", marginBottom: 8 }}>
                    <div style={{ maxWidth: narrow ? "86%" : "72%", wordBreak: "break-word", background: m.from === "admin" ? "#4F46E5" : "#fff", color: m.from === "admin" ? "#fff" : "#111827", padding: "8px 12px", borderRadius: 14, boxShadow: "0 1px 2px rgba(0,0,0,.06)" }}>
                      {m.image ? <img src={img(m.image)} alt="" style={{ maxWidth: "100%", width: 220, borderRadius: 8, display: "block", marginBottom: 6 }} /> : null}
                      <div style={{ whiteSpace: "pre-wrap" }}>{m.text}</div>
                      <div style={{ fontSize: 10.5, opacity: 0.7, marginTop: 3 }}>
                        {when(m.createdAt)} {m.adminEmail ? `· ${m.adminEmail}` : ""}
                      </div>
                    </div>
                  </div>
                ))}
                <div ref={endRef} />
              </div>
              <div className="d-flex" style={{ gap: 6, flexWrap: narrow ? "nowrap" : "wrap", overflowX: narrow ? "auto" : "visible", margin: "10px 0", paddingBottom: narrow ? 2 : 0 }}>
                {quick.map((q) => (
                  <button key={q} className="btn btn-sm btn-outline-secondary" style={{ flexShrink: 0 }} onClick={() => setText(q)}>
                    {q.slice(0, 32)}…
                  </button>
                ))}
              </div>
              {/* minWidth:0 olmadan metin kutusu kucululemiyor ve sayfayi yana tasiriyordu */}
              <div className="d-flex" style={{ gap: 8, alignItems: "flex-start" }}>
                <textarea className="form-control" style={{ flex: 1, minWidth: 0 }} rows={2} value={text} placeholder={narrow ? "Yanıt yaz" : "Yanıt yaz (Enter gönderir, Shift+Enter yeni satır)"} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (!narrow && e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }} />
                <button className="btn btn-primary" style={{ flexShrink: 0 }} onClick={send}>
                  Gönder
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ---------------------------------------------------------- sistem bildirimi
const SystemMsgs = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ title: "", message: "", title_en: "", message_en: "", title_ar: "", message_ar: "", target: "all", userCode: "" });
  // hangi dilin alanlari acik: tr | en | ar
  const [lang, setLang] = useState("tr");
  const [file, setFile] = useState(null);
  // tek kisiye gonderirken kimin secildigini goster (yanlis kisiye bildirim gitmesin)
  const [who, setWho] = useState(null);

  useEffect(() => {
    const code = form.userCode.trim();
    if (form.target !== "one" || code.length < 3) return setWho(null);
    let alive = true;
    const t = setTimeout(async () => {
      const r = await api.staffLookup(code);
      if (alive) setWho(r?.status ? r.account : { notFound: true });
    }, 400);
    return () => {
      alive = false;
      clearTimeout(t);
    };
  }, [form.userCode, form.target]);

  const load = async () => {
    const r = await api.systemMessages();
    if (r?.status) setList(r.messages);
  };
  useEffect(() => {
    load();
  }, []);

  const send = async () => {
    if (!form.title) {
      setLang("tr");
      return window.alert("Türkçe başlık gerekli");
    }
    if (form.target === "one" && (!who || who.notFound)) return window.alert("Kullanıcı bulunamadı — kodu kontrol et");
    const targetText = { all: "HERKESE", users: "tüm kullanıcılara", hosts: "tüm yayıncılara", one: `${who?.name || form.userCode} (${form.userCode})` }[form.target];
    if (!window.confirm(`Bildirim ${targetText} gönderilsin mi?`)) return;
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    const r = await api.sendSystem(fd);
    if (!r?.status) return window.alert(r?.message || "Gönderilemedi");
    setForm({ title: "", message: "", title_en: "", message_en: "", title_ar: "", message_ar: "", target: "all", userCode: "" });
    setLang("tr");
    setWho(null);
    setFile(null);
    load();
  };

  const targetLabel = { all: "Herkes", users: "Kullanıcılar", hosts: "Yayıncılar", one: "Tek kişi" };
  const narrow = useNarrow();
  const del = async (m) => {
    if (window.confirm("Silinsin mi?")) {
      await api.deleteSystem(m._id);
      load();
    }
  };

  return (
    <div className="row">
      <div className="col-lg-5">
        <div className="card">
          <div className="card-body">
            <h6>Yeni sistem bildirimi</h6>
            <p style={{ fontSize: 12, color: "#6B7280" }}>Uygulamada Mesaj › Sistem Bildirimi bölümünde görünür ve telefona yazılı bildirim gider.</p>
            <label style={{ fontSize: 12 }}>Kime</label>
            <select className="form-control" value={form.target} onChange={(e) => setForm({ ...form, target: e.target.value })}>
              <option value="all">Herkes</option>
              <option value="users">Sadece kullanıcılar</option>
              <option value="hosts">Sadece yayıncılar</option>
              <option value="one">Tek kişi</option>
            </select>
            {form.target === "one" && (
              <>
                <input className="form-control" style={{ marginTop: 8 }} placeholder="Kullanıcı kodu ya da ID" value={form.userCode} onChange={(e) => setForm({ ...form, userCode: e.target.value })} />
                {who && (
                  <div className="d-flex align-items-center" style={{ gap: 8, marginTop: 6, fontSize: 13 }}>
                    {who.notFound ? (
                      <span style={{ color: "#DC2626" }}>Kullanıcı bulunamadı</span>
                    ) : (
                      <>
                        <img src={who.image || ""} alt="" style={{ width: 28, height: 28, borderRadius: "50%", objectFit: "cover", background: "#E5E7EB" }} />
                        <b>{who.name}</b>
                        <span style={{ color: "#6B7280" }}>#{who.uniqueID}</span>
                      </>
                    )}
                  </div>
                )}
              </>
            )}
            {/* Her kullaniciya kendi uygulama dilinde gider. Bos birakilan dil Turkceye duser. */}
            <div style={{ display: "flex", gap: 6, marginTop: 14 }}>
              {[
                ["tr", "Türkçe"],
                ["en", "English"],
                ["ar", "العربية"],
              ].map(([code, label]) => {
                const tKey = code === "tr" ? "title" : `title_${code}`;
                const filled = !!form[tKey].trim();
                const on = lang === code;
                return (
                  <button
                    key={code}
                    type="button"
                    className={"btn btn-sm " + (on ? "btn-primary" : "btn-outline-secondary")}
                    onClick={() => setLang(code)}
                  >
                    {label} {filled ? "✓" : code === "tr" ? "*" : ""}
                  </button>
                );
              })}
            </div>
            <div style={{ fontSize: 11.5, color: "#6B7280", marginTop: 6 }}>
              {lang === "tr"
                ? "Zorunlu. Diğer dilleri boş bırakırsan o dildeki kullanıcılara Türkçe gider."
                : form[`title_${lang}`].trim()
                ? "Bu dili kullananlara bu metin gider."
                : "Boş — bu dildeki kullanıcılara Türkçe metin gider."}
            </div>
            {(() => {
              const tKey = lang === "tr" ? "title" : `title_${lang}`;
              const mKey = lang === "tr" ? "message" : `message_${lang}`;
              const dir = lang === "ar" ? "rtl" : "ltr";
              return (
                <>
                  <label style={{ fontSize: 12, marginTop: 10 }}>Başlık</label>
                  <input className="form-control" dir={dir} maxLength={80} value={form[tKey]} onChange={(e) => setForm({ ...form, [tKey]: e.target.value })} />
                  <label style={{ fontSize: 12, marginTop: 10 }}>Mesaj</label>
                  <textarea className="form-control" dir={dir} rows={4} value={form[mKey]} onChange={(e) => setForm({ ...form, [mKey]: e.target.value })} />
                </>
              );
            })()}
            <button className="btn btn-primary" style={{ marginTop: 12 }} onClick={send}>
              Gönder
            </button>
          </div>
        </div>
      </div>
      <div className="col-lg-7" style={narrow ? { marginTop: 12 } : undefined}>
        {narrow ? (
          <Cards
            items={list.map((m) => ({
              key: m._id,
              body: (
                <>
                  <div className="d-flex justify-content-between" style={{ gap: 8 }}>
                    <b style={{ minWidth: 0, wordBreak: "break-word" }}>{m.title}</b>
                    <button className="btn btn-sm btn-outline-danger" style={{ flexShrink: 0 }} onClick={() => del(m)}>
                      Sil
                    </button>
                  </div>
                  <div style={{ fontSize: 13, color: "#6B7280", marginTop: 4, wordBreak: "break-word" }}>{m.message}</div>
                  <div style={{ fontSize: 12, color: "#9CA3AF", marginTop: 6 }}>
                    {targetLabel[m.target]} · {when(m.createdAt)}
                    {m.i18n?.en?.title ? " · EN" : ""}
                    {m.i18n?.ar?.title ? " · AR" : ""}
                  </div>
                </>
              ),
            }))}
          />
        ) : (
        <Table
          head={["Başlık", "Kime", "Tarih", ""]}
          rows={list.map((m) => (
            <tr key={m._id}>
              <td>
                <b>{m.title}</b>
                {m.i18n?.en?.title ? <span style={{ marginLeft: 6, fontSize: 11, color: "#2563EB" }}>EN</span> : null}
                {m.i18n?.ar?.title ? <span style={{ marginLeft: 4, fontSize: 11, color: "#2563EB" }}>AR</span> : null}
                <div style={{ fontSize: 12, color: "#6B7280" }}>{m.message}</div>
              </td>
              <td>{targetLabel[m.target]}</td>
              <td>{when(m.createdAt)}</td>
              <td>
                <button className="btn btn-sm btn-outline-danger" onClick={() => del(m)}>
                  Sil
                </button>
              </td>
            </tr>
          ))}
        />
        )}
      </div>
    </div>
  );
};

// --------------------------------------------------------------- aktiviteler
const toInput = (d) => (d ? new Date(d).toISOString().slice(0, 16) : "");

// 10 gunluk siralamali etkinlik sablonu (kurallar 3 dilde hazir, oduller doldurulur)
const YENI_ETKINLIK = () => ({
  body: "",
  link: "",
  sort: 0,
  isActive: true,
  category: "popular",
  board: true,
  startsAt: toInput(new Date()),
  endsAt: toInput(new Date(Date.now() + 10 * 864e5)),
  rewards: "1 | \n2 | \n3 | \n4-10 | ",
  rules:
    "Etkinlik süresince odalarda gönderilen hediyeler sayılır.\nGönderenler: gönderdiğin hediyelerin coin değeri toplanır.\nAlanlar: yayıncıların aldığı hediyelerin coin değeri toplanır.\nKendine gönderilen hediyeler sayılmaz.\nSıralama her dakika güncellenir.\nÖdüller etkinlik bittikten sonra 24 saat içinde hesabına tanımlanır.",
  rules_en:
    "Gifts sent in rooms during the event count.\nSenders: total coin value of gifts you send.\nReceivers: total coin value of gifts hosts receive.\nGifts to yourself do not count.\nThe ranking updates every minute.\nRewards are added to your account within 24 hours after the event ends.",
  rules_ar:
    "تُحتسب الهدايا المرسلة في الغرف خلال الفعالية.\nالمرسلون: مجموع قيمة الكوينز للهدايا التي ترسلها.\nالمستلمون: مجموع قيمة الكوينز للهدايا التي يستلمها المضيفون.\nالهدايا المرسلة لنفسك لا تُحتسب.\nيتم تحديث الترتيب كل دقيقة.\nتُضاف المكافآت إلى حسابك خلال 24 ساعة بعد انتهاء الفعالية.",
});

const Activities = () => {
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(null);
  const [file, setFile] = useState(null);
  const narrow = useNarrow();

  const load = async () => {
    const r = await api.activities();
    if (r?.status) setList(r.activities);
  };
  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    const fd = new FormData();
    ["title", "body", "link", "sort", "isActive", "category", "board", "rewards", "rules", "rules_en", "rules_ar"].forEach((k) => edit[k] !== undefined && fd.append(k, edit[k]));
    fd.append("startsAt", edit.startsAt ? new Date(edit.startsAt).toISOString() : "");
    fd.append("endsAt", edit.endsAt ? new Date(edit.endsAt).toISOString() : "");
    if (file) fd.append("image", file);
    const r = await api.saveActivity(edit._id, fd);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setEdit(null);
    setFile(null);
    load();
  };

  return (
    <>
      <div className="d-flex justify-content-end" style={{ marginBottom: 10 }}>
        <button className="btn btn-outline-primary" style={{ marginRight: 8 }} onClick={() => setEdit({ ...YENI_ETKINLIK(), title: "" })}>
          Yeni etkinlik (sıralamalı, 10 gün)
        </button>
        <button className="btn btn-primary" onClick={() => setEdit({ title: "", body: "", link: "", sort: 0, isActive: true, category: "popular", startsAt: toInput(new Date()), endsAt: "" })}>
          Yeni aktivite
        </button>
      </div>
      {narrow ? (
        <Cards
          items={list.map((a) => ({
            key: a._id,
            body: (
              <>
                {a.image ? <img src={img(a.image)} alt="" style={{ width: "100%", borderRadius: 8, marginBottom: 8, display: "block" }} /> : null}
                <div className="d-flex justify-content-between align-items-start" style={{ gap: 8 }}>
                  <b style={{ minWidth: 0, wordBreak: "break-word" }}>{a.title}</b>
                  {a.isActive ? <Chip>Yayında</Chip> : <Chip kind="wait">Kapalı</Chip>}
                </div>
                <div style={{ fontSize: 13, color: "#6B7280", marginTop: 4, wordBreak: "break-word" }}>{a.body}</div>
                {a.board && (
                  <a href={`https://badulive.online/event/${a._id}`} target="_blank" rel="noreferrer" style={{ fontSize: 12.5 }}>
                    🏆 Sıralama sayfası ↗
                  </a>
                )}
                <div style={{ fontSize: 12, color: "#9CA3AF", marginTop: 6 }}>
                  {{ popular: "Popüler", recharge: "Yükleme", daily: "Günlük" }[a.category || "popular"]} · {when(a.startsAt)} → {a.endsAt ? when(a.endsAt) : "Süresiz"}
                </div>
                <div className="d-flex" style={{ gap: 6, marginTop: 10 }}>
                  <button className="btn btn-sm btn-outline-primary" style={{ flex: 1 }} onClick={() => setEdit({ ...a, startsAt: toInput(a.startsAt), endsAt: toInput(a.endsAt) })}>
                    Düzenle
                  </button>
                  <button className="btn btn-sm btn-outline-danger" style={{ flex: 1 }} onClick={async () => { if (window.confirm("Silinsin mi?")) { await api.deleteActivity(a._id); load(); } }}>
                    Sil
                  </button>
                </div>
              </>
            ),
          }))}
        />
      ) : (
      <Table
        head={["Görsel", "Başlık", "Başlangıç", "Bitiş", "Durum", ""]}
        rows={list.map((a) => (
          <tr key={a._id}>
            <td>{a.image ? <img src={img(a.image)} alt="" style={{ height: 44, borderRadius: 6 }} /> : "—"}</td>
            <td>
              <b>{a.title}</b> <span style={{ fontSize: 12, color: "#6B7280" }}>· {{ popular: "Popüler", recharge: "Yükleme", daily: "Günlük" }[a.category || "popular"]}</span>
              {a.board && (
                <a href={`https://badulive.online/event/${a._id}`} target="_blank" rel="noreferrer" style={{ marginLeft: 6, fontSize: 12 }}>
                  🏆 sıralama sayfası ↗
                </a>
              )}
              <div style={{ fontSize: 12, color: "#6B7280" }}>{a.body}</div>
            </td>
            <td>{when(a.startsAt)}</td>
            <td>{a.endsAt ? when(a.endsAt) : "Süresiz"}</td>
            <td>{a.isActive ? <Chip>Yayında</Chip> : <Chip kind="wait">Kapalı</Chip>}</td>
            <td style={{ whiteSpace: "nowrap" }}>
              <button className="btn btn-sm btn-outline-primary" onClick={() => setEdit({ ...a, startsAt: toInput(a.startsAt), endsAt: toInput(a.endsAt) })}>
                Düzenle
              </button>{" "}
              <button className="btn btn-sm btn-outline-danger" onClick={async () => { if (window.confirm("Silinsin mi?")) { await api.deleteActivity(a._id); load(); } }}>
                Sil
              </button>
            </td>
          </tr>
        ))}
      />
      )}
      <Modal open={!!edit} title={edit?._id ? "Aktiviteyi düzenle" : "Yeni aktivite"} onClose={() => setEdit(null)}>
        {edit && (
          <>
            <label style={{ fontSize: 12 }}>Başlık</label>
            <input className="form-control" value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} />
            <label style={{ fontSize: 12, marginTop: 8 }}>Etkinlik Merkezi sekmesi</label>
            <select className="form-control" value={edit.category || "popular"} onChange={(e) => setEdit({ ...edit, category: e.target.value })}>
              <option value="popular">Popüler</option>
              <option value="recharge">Yükleme</option>
              <option value="daily">Günlük</option>
            </select>
            <label style={{ fontSize: 12, marginTop: 8 }}>Açıklama</label>
            <textarea className="form-control" rows={3} value={edit.body} onChange={(e) => setEdit({ ...edit, body: e.target.value })} />
            <label style={{ fontSize: 12, marginTop: 8 }}>Detay bağlantısı (https, isteğe bağlı)</label>
            <input className="form-control" value={edit.link} onChange={(e) => setEdit({ ...edit, link: e.target.value })} />
            <div className="d-flex" style={{ gap: 8, marginTop: 8, flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 200px" }}>
                <label style={{ fontSize: 12 }}>Başlangıç</label>
                <input className="form-control" type="datetime-local" value={edit.startsAt} onChange={(e) => setEdit({ ...edit, startsAt: e.target.value })} />
              </div>
              <div style={{ flex: "1 1 200px" }}>
                <label style={{ fontSize: 12 }}>Bitiş (boş = süresiz)</label>
                <input className="form-control" type="datetime-local" value={edit.endsAt} onChange={(e) => setEdit({ ...edit, endsAt: e.target.value })} />
              </div>
            </div>
            <div style={{ marginTop: 12, padding: 10, borderRadius: 10, background: "#F5F3FF" }}>
              <label style={{ margin: 0, fontWeight: 600 }}>
                <input type="checkbox" checked={!!edit.board} onChange={(e) => setEdit({ ...edit, board: e.target.checked })} /> Sıralamalı etkinlik sayfası
              </label>
              <div style={{ fontSize: 11.5, color: "#6B7280", marginTop: 2 }}>
                Açıksa karta basınca badulive.online/event/… açılır: hediye gönderen ve alan sıralaması, ödüller, kurallar. Sıralama başlangıç–bitiş arasındaki hediyelerden hesaplanır.
              </div>
              {edit.board && (
                <>
                  <label style={{ fontSize: 12, marginTop: 8 }}>Ödüller (her satır: sıra | ödül)</label>
                  <textarea className="form-control" rows={5} value={edit.rewards || ""} placeholder={"1 | SVIP3 + 50.000 coin\n2 | VIP6 + 25.000 coin\n4-10 | 5.000 coin"} onChange={(e) => setEdit({ ...edit, rewards: e.target.value })} />
                  <label style={{ fontSize: 12, marginTop: 8 }}>Kurallar — Türkçe (her satır bir madde)</label>
                  <textarea className="form-control" rows={4} value={edit.rules || ""} onChange={(e) => setEdit({ ...edit, rules: e.target.value })} />
                  <label style={{ fontSize: 12, marginTop: 8 }}>Kurallar — English</label>
                  <textarea className="form-control" rows={3} value={edit.rules_en || ""} onChange={(e) => setEdit({ ...edit, rules_en: e.target.value })} />
                  <label style={{ fontSize: 12, marginTop: 8 }}>Kurallar — العربية</label>
                  <textarea className="form-control" dir="rtl" rows={3} value={edit.rules_ar || ""} onChange={(e) => setEdit({ ...edit, rules_ar: e.target.value })} />
                  {edit._id && (
                    <a href={`https://badulive.online/event/${edit._id}`} target="_blank" rel="noreferrer" style={{ display: "inline-block", marginTop: 8, fontSize: 12.5 }}>
                      Sayfayı aç ↗
                    </a>
                  )}
                </>
              )}
            </div>
            <label style={{ fontSize: 12, marginTop: 8 }}>Kapak görseli (yatay, önerilen 1200×400)</label>
            <input className="form-control" type="file" accept="image/*" onChange={(e) => setFile(e.target.files?.[0] || null)} />
            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 12 }}>
              <label style={{ margin: 0 }}>
                <input type="checkbox" checked={!!edit.isActive} onChange={(e) => setEdit({ ...edit, isActive: e.target.checked })} /> Yayında
              </label>
              <button className="btn btn-primary" disabled={!edit.title} onClick={save}>
                Kaydet
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

// ------------------------------------------------------------- arkadaslik
const Friends = () => {
  const [d, setD] = useState(null);
  const narrow = useNarrow();
  useEffect(() => {
    api.friendStats().then((r) => r?.status && setD(r));
  }, []);
  if (!d) return <div className="badu-empty">Yükleniyor…</div>;
  return (
    <>
      <Tiles
        items={[
          { label: "Bekleyen istek", value: fmt(d.pending) },
          { label: "Kabul edilen", value: fmt(d.accepted) },
          { label: "Reddedilen", value: fmt(d.declined) },
        ]}
      />
      {narrow ? (
        <Cards
          items={d.recent.map((r) => ({
            key: r._id,
            body: (
              <>
                <div className="d-flex justify-content-between align-items-center" style={{ gap: 8 }}>
                  <div style={{ minWidth: 0, overflow: "hidden" }}>
                    <Person image={r.fromImage} name={r.fromName} />
                  </div>
                  {r.state === "accepted" ? <Chip>Kabul</Chip> : r.state === "declined" ? <Chip kind="bad">Red</Chip> : <Chip kind="wait">Bekliyor</Chip>}
                </div>
                <div style={{ fontSize: 13, marginTop: 6 }}>→ {r.toName}</div>
                {r.message ? <div style={{ fontSize: 13, color: "#6B7280", marginTop: 2, wordBreak: "break-word" }}>{r.message}</div> : null}
                <div style={{ fontSize: 12, color: "#9CA3AF", marginTop: 4 }}>{when(r.createdAt)}</div>
              </>
            ),
          }))}
        />
      ) : (
      <Table
        head={["Gönderen", "Alan", "Mesaj", "Durum", "Tarih"]}
        rows={d.recent.map((r) => (
          <tr key={r._id}>
            <td>
              <Person image={r.fromImage} name={r.fromName} />
            </td>
            <td>{r.toName}</td>
            <td>{r.message || "—"}</td>
            <td>{r.state === "accepted" ? <Chip>Kabul</Chip> : r.state === "declined" ? <Chip kind="bad">Red</Chip> : <Chip kind="wait">Bekliyor</Chip>}</td>
            <td>{when(r.createdAt)}</td>
          </tr>
        ))}
      />
      )}
    </>
  );
};

// Odalara duyuru: acik sesli odalarin (istege bagli canli yayinlarin) sohbetine AYVO adina mesaj
const OdaDuyuru = () => {
  const [text, setText] = useState("");
  const [region, setRegion] = useState("all");
  const [live, setLive] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const gonder = async () => {
    if (!text.trim()) return setMsg("Mesaj yazın.");
    if (!window.confirm("Bu mesaj odaların sohbetine AYVO adına gönderilecek. Emin misiniz?")) return;
    setBusy(true);
    setMsg("");
    try {
      const r = await api.roomAnnounce(text.trim(), region, live);
      setMsg(r?.message || (r?.status ? "Gönderildi" : "Gönderilemedi"));
      if (r?.status) setText("");
    } catch (e) {
      setMsg("Gönderilemedi");
    }
    setBusy(false);
  };
  return (
    <div className="card" style={{ marginBottom: 14 }}>
      <div className="card-body">
        <h5 style={{ marginBottom: 6 }}>Odalara duyuru</h5>
        <div style={{ color: "#888", fontSize: 13, marginBottom: 10 }}>Açık sesli odaların sohbetine AYVO adına mesaj düşer.</div>
        <textarea className="form-control" rows={3} maxLength={300} value={text} onChange={(e) => setText(e.target.value)} placeholder="Örn: Bu akşam 21:00'de PK turnuvası başlıyor!" />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", marginTop: 10 }}>
          <select className="form-control" style={{ width: 170 }} value={region} onChange={(e) => setRegion(e.target.value)}>
            <option value="all">Tüm odalar</option>
            <option value="tr">Türk odaları</option>
            <option value="ar">Arap odaları</option>
          </select>
          <label style={{ margin: 0, display: "flex", gap: 6, alignItems: "center" }}>
            <input type="checkbox" checked={live} onChange={(e) => setLive(e.target.checked)} /> Canlı yayınlara da gönder
          </label>
          <button className="btn btn-primary" disabled={busy} onClick={gonder}>{busy ? "Gönderiliyor…" : "Gönder"}</button>
          {msg && <span style={{ fontSize: 13 }}>{msg}</span>}
        </div>
      </div>
    </div>
  );
};

const InboxAdmin = () => {
  const [tab, setTab] = useState("support");
  return (
    <>
      <PageHead title="Mesaj Merkezi" sub="Uygulamadaki Mesaj sekmesinin yönetimi: müşteri hizmetleri, sistem bildirimleri, aktiviteler ve arkadaşlık istekleri." />
      <OdaDuyuru />
      <ScrollTabs
        value={tab}
        onChange={setTab}
        tabs={[
          ["support", "Müşteri Hizmetleri"],
          ["system", "Sistem Bildirimi"],
          ["activity", "Aktiviteler"],
          ["friends", "Arkadaşlık İstekleri"],
        ]}
      />
      {tab === "support" && <Support />}
      {tab === "system" && <SystemMsgs />}
      {tab === "activity" && <Activities />}
      {tab === "friends" && <Friends />}
    </>
  );
};

export default InboxAdmin;
